module.exports = __webpack_public_path__ + "img/NOTIFICACIONESWEB.c301167d.svg";